(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sw-footer-scene-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sw-footer-scene-motion')) {
  customElements.define('sw-footer-scene-motion', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this._focalTimers = new Map();
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._canRun = () => !document.hidden && !this._motion.matches && !document.body.classList.contains('vp_filter_stop_animations') && !document.body.classList.contains('paused');
      this._stopFocal = (focal) => {
        window.clearTimeout(this._focalTimers.get(focal));
        this._focalTimers.delete(focal);
        focal.removeAttribute('data-playing');
      };
      this._stop = () => {
        Array.from(this._focalTimers.keys()).forEach(this._stopFocal);
        this.removeAttribute('data-running');
      };
      this._playFocal = (focal) => {
        if (!this._canRun() || !focal.hasAttribute('data-in-view')) {
          this._stopFocal(focal);
          return;
        }
        focal.removeAttribute('data-playing');
        focal.querySelectorAll('.swfm-effect, .swfm-motion').forEach((effect) => {
          window.getComputedStyle(effect).animationName;
        });
        focal.setAttribute('data-playing', '');
        this._focalTimers.set(focal, window.setTimeout(() => this._playFocal(focal), 2800));
      };
      this._update = () => {
        const focals = Array.from(this.querySelectorAll('.swfm-focal'));
        const visible = focals.filter((focal) => focal.hasAttribute('data-in-view'));
        if (!this._canRun() || visible.length === 0) {
          this._stop();
          return;
        }
        this.setAttribute('data-running', '');
        Array.from(this._focalTimers.keys()).forEach((focal) => {
          if (!visible.includes(focal)) this._stopFocal(focal);
        });
        visible.forEach((focal) => {
          if (!this._focalTimers.has(focal)) {
            const phase = (focals.indexOf(focal) % 6) * (2800 / 6);
            this._focalTimers.set(focal, window.setTimeout(() => this._playFocal(focal), phase));
          }
        });
      };
      this._bodyObserver = new MutationObserver(this._update);
      this._bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => entry.target.parentElement.toggleAttribute('data-in-view', entry.isIntersecting && entry.intersectionRatio >= .25));
        this._update();
      }, { threshold: .25 });
      this.querySelectorAll('.swfm-trigger').forEach((trigger) => this._observer.observe(trigger));
      this._motion.addEventListener('change', this._update);
      document.addEventListener('visibilitychange', this._update);
      this._update();
    }
    disconnectedCallback() {
      this._stop?.();
      this._observer?.disconnect();
      this._bodyObserver?.disconnect();
      this._motion?.removeEventListener('change', this._update);
      document.removeEventListener('visibilitychange', this._update);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sweetweet-approved-product"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.swReady)return;root.dataset.swReady='true';
    var scope=root.closest('[data-section-type="product"]');
    var form=document.getElementById(root.dataset.formId);
    if(!scope||!form)return;
    var button=form.querySelector('[data-add-to-cart]');
    var bar=root.querySelector('[data-sw-sticky]');
    var alternatives=root.querySelector('[data-sw-alternatives]');
    var price=scope.querySelector('[data-product-detail-price]');
    var originalVisible=true;
    function sync(){
      button=form.querySelector('[data-add-to-cart]');
      var rect=button&&button.getBoundingClientRect();
      originalVisible=!!rect&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight;
      var available=button&&!button.disabled&&button.getAttribute('aria-disabled')!=='true';
      var overlay=Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(function(el){return el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden';});
      var editing=/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
      // Let the real footer remain unobstructed; keep all existing purchase guards.
      var footer=document.querySelector('footer.page-footer[data-section-type="footer"]');
      var footerRect=footer&&footer.getBoundingClientRect();
      var footerVisible=!!footerRect&&footerRect.width>0&&footerRect.height>0&&footerRect.bottom>0&&footerRect.top<window.innerHeight;
      bar.hidden=!available||originalVisible||!!overlay||editing||footerVisible;
      document.body.classList.toggle('sw-sticky-active',!bar.hidden);
      if(price&&bar.querySelector('[data-sw-price]').textContent!==price.textContent)bar.querySelector('[data-sw-price]').textContent=price.textContent;
      if(alternatives)alternatives.hidden=!!available;
    }
    var scheduled=false;function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;sync();});}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
    new MutationObserver(schedule).observe(form,{attributes:true,childList:true,subtree:true});
    if(price)new MutationObserver(sync).observe(price,{childList:true,characterData:true,subtree:true});
    bar.querySelector('button').addEventListener('click',function(){
      var target=scope.querySelector('.product-detail__options')||form;
      var gpo=scope.querySelector('.gpo-app');if(gpo)target=gpo;
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      var field=target.querySelector('input:not([type="hidden"]):not(.no-js),select:not(.no-js),textarea,button');if(field)field.focus({preventScroll:true});
    });
    document.addEventListener('focusin',sync);document.addEventListener('focusout',function(){setTimeout(sync,0)});form.addEventListener('change',sync);
    sync();
  }
  function run(){document.querySelectorAll('[data-sw-approved]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
  } catch(e) { console.error(e); }
})();

})();
